import React from "react";
import Navbar from "../components/layout/header/Navbar";
import Footer from "../components/layout/footer/Footer";
import Policy from "../components/others/Policy";

export default function PrivacyPolicy() {
  return (
    <div>
      <Navbar />
      <Policy />
      <Footer />
    </div>
  );
}
